// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse_collapse__2-4Me","collapse_compact":"collapse_collapse_compact__tEexc"};